import React from 'react';
import {
  CompositeReportDefinitionSummary,
  TemplateSummary,
  TemplatingItemSummary,
} from '../../../models';
import { TemplateNode } from './TemplateNode';
import { CompositeReportDefinitionNode } from './CompositeReportDefinitionNode';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { useDraggable } from '@dnd-kit/core';

type TemplatingItemNodeProps = {
  templatingItem: TemplatingItemSummary;
  templateNodeActions?: (data: TemplateSummary) => React.ReactNode;
  compositeReportDefinitionNodeActions?: (
    data: CompositeReportDefinitionSummary,
  ) => React.ReactNode;
};

export const TemplatingItemNode = React.forwardRef<
  HTMLDivElement,
  TemplatingItemNodeProps
>(
  (
    {
      templatingItem,
      templateNodeActions,
      compositeReportDefinitionNodeActions,
      ...props
    },
    ref,
  ) => {
    let node: React.ReactNode;
    if (templatingItem.type === 'template') {
      node = (
        <TemplateNode
          template={templatingItem}
          templateNodeActions={templateNodeActions}
        />
      );
    } else {
      node = (
        <CompositeReportDefinitionNode
          compositeReportDefinition={templatingItem}
          compositeReportDefinitionNodeActions={
            compositeReportDefinitionNodeActions
          }
        />
      );
    }
    return (
      <Box ref={ref} {...props} fullWidth>
        {node}
      </Box>
    );
  },
);

export const DraggableTemplatingItemNode: React.FC<TemplatingItemNodeProps> = ({
  templatingItem,
  templateNodeActions,
  compositeReportDefinitionNodeActions,
}) => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: templatingItem.path,
    data: { templatingItem },
  });
  return (
    <TemplatingItemNode
      ref={setNodeRef}
      templatingItem={templatingItem}
      templateNodeActions={templateNodeActions}
      compositeReportDefinitionNodeActions={
        compositeReportDefinitionNodeActions
      }
      {...attributes}
      {...listeners}
    />
  );
};
